import { tryFetch, HttpMethod, type HttpResponse } from '@/services/http'
import type { ApplicationSetting } from '../types/setting.enum'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getApplicationSettings = async (
  body: ApplicationSetting[],
): Promise<HttpResponse<{ [id: number]: string }, any>> =>
  await tryFetch<{ [id: number]: string }, any>(HttpMethod.Post, BASE_URL, 'settings/application', {
    body,
  })

export const settingApi = {
  getApplicationSettings,
}
